import styled from "styled-components";

const HeaderContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;

  flex: 0 0;
  min-height: 70px;
  margin-bottom: 20px;
  margin-top: 20px;

  @media (max-width: 480px) {
    flex: 1 0;
    min-height: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

export default HeaderContainer;
